import { ActionReducerMap } from '@ngrx/store';

import * as fromQuickQuoteDataReducer from './quick-quote-data/quick-quote-data.reducer';

export interface ReplaceVehicleDataState {
  quickQuote: fromQuickQuoteDataReducer.QuickQuoteDataState;
}

export const replaceVehicleDataReducers: ActionReducerMap<ReplaceVehicleDataState> = {
  quickQuote: fromQuickQuoteDataReducer.reducer
};
